import './badge.scss';

const Badge = (props) => <div className="uhc-badge" {...props} />;

export default Badge;
